import Axios from 'axios';

export default Axios.create({
  // baseURL: 'http://localhost:8080/api',
  // baseURL: 'http://69.62.90.26:8080/coto/api',
  baseURL: 'https://elocotacao.com.br:8443/coto/api',
  withCredentials: true,
});
